import React from 'react'
import "./AboutSlider.css"

export const AboutSlider = () => {
  return (
    <div class="container">
    <div class="slider">
        <div class="slide slide1">
            <div class="caption">
                <h2>Our history</h2>
                <p>Partnering with WSUP Toronto in 2016.</p><br/>
                <p>we became the first kayak rental business in Toronto's east beaches. Family-owned and run. 
                  Fully licensed with the City of Toronto. Fully insured.</p>
              
            </div>
        </div>
        <div class="slide slide2">
            <div class="caption">
                <h2>Our mission</h2>
                <p>To provide a fun and safe kayak experience to beginners and experienced paddlers alike.</p><br/>
              <p>To promote water quality and water safety awareness.</p>
            
            </div>
        </div>
        <div class="slide slide3">
        <div class="caption">
                <h2>Our history</h2>
                <p>Partnering with WSUP Toronto in 2016.</p><br/>
                <p>we became the first kayak rental business in Toronto's east beaches. Family-owned and run. 
                  Fully licensed with the City of Toronto. Fully insured.</p>
              
            </div>
        </div>
        <div class="slide slide4">
        <div class="caption">
                <h2>Our mission</h2>
                <p>To provide a fun and safe kayak experience to beginners and experienced paddlers alike.</p><br/>
              <p>To promote water quality and water safety awareness.</p>
            
            </div>
        </div>
        <div class="slide slide5">
        <div class="caption">
                <h2>Our history</h2>
                <p>Partnering with WSUP Toronto in 2016.</p><br/>
                <p>we became the first kayak rental business in Toronto's east beaches. Family-owned and run. 
                  Fully licensed with the City of Toronto. Fully insured.</p>
              
            </div>
        </div>
    </div>
   
</div>
  )
}
